import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import { ErrorAlertModule } from '@/store/modules/errors';
import { getDisclaimer, GetDisclaimerResponse } from '@/api/main';
import { StatementType } from '@/types/services';
import { errorHandler } from "@/utils/common";


export interface IDisclaimerState {
  text: GetDisclaimerResponse['message'] | null;
  loading: boolean;
  loaded: boolean;
}

@Module({ dynamic: true, store, name: 'disclaimer', namespaced: true })
class Disclaimer extends VuexModule implements IDisclaimerState {
  text: GetDisclaimerResponse['message'] | null = null;
  loaded = false;
  loading = false;

  @Mutation
  pending() {
    ErrorAlertModule.setErrorAlert('');
    this.text = null;
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  fulfilled(data: GetDisclaimerResponse['message']) {
    this.text = data;
    this.loading = false;
    this.loaded = true;
  }

  @Mutation
  rejected(error: unknown) {
    errorHandler(error)
    this.loading = false;
    this.loaded = false;
  }

  @Action
  async get(statementType: StatementType) {
    this.pending();

    try {
      const data = await getDisclaimer(statementType);
      this.fulfilled(data.message);
    } catch (error) {
      this.rejected(error);
    }
  }
}

export const DisclaimerModule = getModule(Disclaimer);
